import IsPerformanceResourceSupported from './IsPerformanceResourceSupported';

/**
 * Returns current performance time value
 */
export default function safePerformanceNow(): number {
    if (IsPerformanceResourceSupported) {
        return performance?.now();
    }
    return 0;
}
